import { React, useState, useEffect } from "react";
import "./Login-signup.css";
import { useFormik } from "formik";
import {
  setUserLogin,
  setLoginLoading,
  handleRegister,
  clearLoginMessage,
} from "../service/loginServices";
import { useSelector, useDispatch } from "react-redux";

function LoginSignUp() {
  const dispatch = useDispatch();
  const logindata = useSelector((state) => state.user);
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    password: "",
  };

  const [formState, setFormState] = useState("login");
  const onSubmit = (values, submitProps) => {
    console.log(values);
    console.log(login);
    dispatch(setLoginLoading());
    if (formState === "login") {
      dispatch(setUserLogin(values.email, values.password));
    } else {
      dispatch(
        handleRegister(values.name, values.email, values.phone, values.password)
      ).then();
    }
    localStorage.setItem("userLoginStatus", logindata.isLoggedIn);
    submitProps.setSubmitting(false);
    submitProps.resetForm();
  };

  useEffect(() => {
    if (formState === "login") {
      setCurrentForm(login);
    } else if (formState === "signup") {
      setCurrentForm(signup);
    }
  }, [formState]);
  const login = [
    {
      label: "Email",
      type: "text",
      id: "email",
      name: "email",
      placeholder: "Enter your Email",
    },
    {
      label: "Password",
      name: "password",
      type: "password",
      placeholder: "Enter your Password",
    },
  ];

  const signup = [
    {
      label: "Name",
      type: "text",
      name: "name",
      placeholder: "Enter your name",
    },
    {
      label: "Email",
      type: "text",
      name: "email",
      placeholder: "Enter your email",
    },
    {
      label: "Phone",
      type: "text",
      name: "phone",
      placeholder: "Enter your phone number",
    },
    {
      label: "Password",
      type: "password",
      name: "password",
      placeholder: "Enter a screte Password",
    },
    // {
    //   label: "Confirm Password",
    //   type: "password",
    //   placeholder: "Confirm Password",
    // },
  ];
  const [currentForm, setCurrentForm] = useState(login);
  const formik = useFormik({
    initialValues,
    onSubmit: onSubmit,

    validate: (values) => {
      let errors = {};
      let re = {
        capital: /(?=.*[A-Z])/,
        length: /(?=.{7,40}$)/,
        specialChar: /[ -\/:-@\[-\`{-~]/,
        digit: /(?=.*[0-9])/,
      };
      if (values.password.length == 0) {
        errors.password = "Please enter a valid pasword";
      }

      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.email)) {
        errors.email = "Please enter a valid email";
      }
      var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (formState === "signup" && !values.phone.match(phoneno)) {
        errors.phone = "Please enter a valid phone number";
      }

      if (formState === "signup" && values.name.length === 0) {
        errors.phone = "Please enter a valid name";
      }

      return errors;
    },
  });

  let signBtnText = "";
  if (logindata.isLoading) {
    signBtnText = "Loading...";
  } else if (formState === "login") {
    signBtnText = "Log In";
  } else {
    signBtnText = "Sign Up";
  }
  return (
    <div className="sign_page_container">
      <div className="sign_items_container">
        <h1 className="sign_heading sign_element">
          {formState === "login" ? "Welcome Back" : "Welcome"}
        </h1>
        <p className="sign_text sign_element">
          Decentralized Cloud Storage System
        </p>
        <form onSubmit={formik.handleSubmit}>
          {currentForm.map((item) => {
            const { id, name, placeholder, type } = item;
            return (
              <div>
                <label htmlFor={item.label} className="sign_label sign_element">
                  {item.label}
                </label>
                <br />
                <input
                  type={type}
                  id={id}
                  name={name}
                  placeholder={placeholder}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values[name]}
                  className="sign_input_field sign_element"
                  required
                />
                {formik.touched[name] && formik.errors[name] ? (
                  <div className="sign_error_msg">{formik.errors[name]}</div>
                ) : null}
              </div>
            );
          })}
          {/* {formState === "login" && (
            <p className="forgot_password sign_element"> Forgot Password?</p>
          )} */}

          <button
            type="submit"
            id={formState}
            value={formState}
            className="sign_button sign_element"
          >
            {signBtnText}
          </button>
        </form>

        {logindata && logindata.logInMessage && (
          <div className="sign_header_message">{logindata.logInMessage} </div>
        )}

        {formState === "login" ? (
          <div className="sign_footer sign_element">
            <span> Don't have an account? </span>
            <span
              className="sign_footer_link"
              onClick={() => {
                setFormState("signup");
                formik.setTouched({}, false);
                console.log(formik.errors);
                dispatch(clearLoginMessage());
              }}
            >
              Sign Up
            </span>{" "}
          </div>
        ) : (
          <div className="sign_footer">
            <span>Already have an account? </span>
            <span
              className="sign_footer_link"
              onClick={() => {
                setFormState("login");
                formik.setTouched({}, false);
                console.log(formik.errors);
                dispatch(clearLoginMessage());
              }}
            >
              Login
            </span>{" "}
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginSignUp;
